import { useEffect } from 'react';
import { getSEO, SEOStore } from './seoStore';
function setMeta(name: string, content: string) {
  let el = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('name', name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}
function setOGMeta(property: string, content: string) {
  let el = document.querySelector(`meta[property="${property}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('property', property);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}
export function useSEO(page: keyof SEOStore) {
  useEffect(() => {
    const seo = getSEO()[page];
    document.title = seo.title;
    setMeta('description', seo.description);
    setMeta('keywords', seo.keywords);
    setOGMeta('og:title', seo.title);
    setOGMeta('og:description', seo.description);
    setOGMeta('og:type', 'website');
  }, [page]);
}